module.exports = __webpack_public_path__ + "static/media/user.1338ddc3.png";